<template>
  <div class="summary-cards mb-[16px]">
    <!-- Row 1: 4 cards -->
    <div class="d-flex flex-wrap gap-[12px] mb-[12px]">
      <!-- Card 1: Last Pickup -->
      <div class="summary-card flex-1">
        <div class="d-flex align-items-center gap-[8px] mb-[8px]">
          <div class="card-icon bg-[#FEF2F2]">
            <span class="k-calendar text-[#F95031] text-[12px]" />
          </div>
          <span class="card-label">Last Pickup</span>
        </div>
        <div class="card-value">
          {{ summaryData.lastPickup.date || 'Belum' }}
        </div>
        <div
          class="card-sub mt-[4px]"
        >
          {{ summaryData.lastPickup.time ? summaryData.lastPickup.time + ' WIB' : '-' }}
        </div>
      </div>

      <!-- Card 2: Total Order -->
      <div class="summary-card flex-1">
        <div class="d-flex align-items-center gap-[8px] mb-[8px]">
          <div class="card-icon bg-[#EFF6FF]">
            <span class="k-bag-2 text-[#08A0F7] text-[12px]" />
          </div>
          <span class="card-label">Total Order</span>
        </div>
        <div class="card-value">
          {{ formatNumber(summaryData.totalOrder) }}
        </div>
      </div>

      <!-- Card 3: Total Transaksi -->
      <div class="summary-card flex-1">
        <div class="d-flex align-items-center gap-[8px] mb-[8px]">
          <div class="card-icon bg-[#F0FDF4]">
            <span class="k-moneys text-[#34A770] text-[12px]" />
          </div>
          <span class="card-label">Total Transaksi</span>
        </div>
        <div class="card-value">
          {{ formatIDR(summaryData.totalTransaksi).replace(/\s+/g, '') }}
        </div>
      </div>

      <!-- Card 4: Total Ongkir -->
      <div class="summary-card flex-1">
        <div class="d-flex align-items-center gap-[8px] mb-[8px]">
          <div class="card-icon bg-[#FFF2E2]">
            <span class="k-empty-wallet text-[#FBA63C] text-[12px]" />
          </div>
          <span class="card-label">Total Ongkir</span>
        </div>
        <div class="card-value">
          {{ formatIDR(summaryData.totalOngkir) }}
        </div>
      </div>
    </div>

    <!-- Row 2: 3 cards -->
    <div class="d-flex flex-wrap gap-[12px]">
      <!-- Card 5: Level Terakhir -->
      <div class="summary-card flex-1">
        <div class="d-flex align-items-center gap-[8px] mb-[8px]">
          <div class="card-icon bg-[#E8DEF8]">
            <span class="k-ranking text-[#6750A4] text-[12px]" />
          </div>
          <span class="card-label">Level Terakhir</span>
        </div>
        <template v-if="summaryData.level.from === summaryData.level.to || !summaryData.level.to">
          <!-- belum naik level, tampil 1 badge saja -->
          <div class="level-badge-wrapper d-flex align-items-center gap-[6px] mb-[4px]">
            <span class="level-badge-from">{{ summaryData.level.from }}</span>
          </div>
        </template>
        <template v-else>
          <!-- sudah naik level -->
          <div class="level-badge-wrapper d-flex align-items-center gap-[6px] mb-[4px]">
            <span class="level-badge-from">{{ summaryData.level.from }}</span>
            <img
              v-if="summaryData.level.fromIcon"
              :src="summaryData.level.fromIcon"
              alt="from-level"
              class="w-[18px]"
            >
            <span class="arrow">→</span>
            <span class="level-badge-to">{{ summaryData.level.to }}</span>
            <img
              v-if="summaryData.level.toIcon"
              :src="summaryData.level.toIcon"
              alt="to-level"
              class="w-[18px]"
            >
          </div>
        </template>
        <div class="card-sub">
          {{ summaryData.level.date }}
        </div>
      </div>

      <!-- Card 6: Rasio Problem -->
      <div class="summary-card flex-1">
        <div class="d-flex align-items-center gap-[8px] mb-[8px]">
          <div class="card-icon bg-[#FFF2E2]">
            <span class="k-percentage-circle text-[#FBA63C] text-[12px]" />
          </div>
          <span class="card-label">Rasio Problem</span>
          <img
            id="rasio-problem-info"
            src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
            alt="info"
            class="cursor-pointer w-[16px] ml-auto"
          >
          <b-tooltip
            target="rasio-problem-info"
            triggers="hover"
            placement="bottomleft"
          >
            {{ summaryData.rasioProblem.detail }}
          </b-tooltip>
        </div>
        <div>
          <div class="card-value">
            {{ summaryData.rasioProblem.percentage }}%
          </div>
          <div class="text-[#828282] text-[12px] mt-[12px]">
            {{ summaryData.rasioProblem.ratio }}
          </div>
        </div>
      </div>

      <!-- Card 7: Rasio Retur -->
      <div class="summary-card flex-1">
        <div class="d-flex align-items-center gap-[8px] mb-[8px]">
          <div class="card-icon bg-[#FFEDED]">
            <span class="k-box text-[#E31A1A] text-[12px]" />
          </div>
          <span class="card-label">Rasio Retur</span>
        </div>
        <div class="card-value">
          {{ summaryData.rasioRetur.percentage }}%
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'
import { newAxiosIns } from '@/libs/axios'
import { DAY_MONTH_YEAR, TIME } from '@/libs/filterDate'

export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      IDR,
      loading: false,

      summaryData: {
        lastPickup: {
          date: null,
          time: null,
        },
        totalOrder: 0,
        totalTransaksi: 0,
        totalOngkir: 0,
        level: {
          from: null,
          to: null,
          verified: false,
          date: null,
        },
        rasioProblem: {
          percentage: 0,
          ratio: '0/0',
          detail: 'Paket Hilang 0% (0/0)',
        },
        rasioRetur: {
          percentage: 0,
        },
      },
    }
  },
  mounted() {
    this.fetchSummaryData()
  },
  methods: {

    formatIDR(value) {
      return IDR(value).replace(/\s+/g, '').replace('Rp.', 'Rp')
    },

    formatNumber(num) {
      if (!num) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    getIconLevel(levelName) {
      // Pastikan pencarian nama level aman walau beda besar/kecil huruf
      const name = (levelName || '').toLowerCase()
      if (name === 'juragan') {
        return 'https://storage.googleapis.com/komerce/assets/icons/badge_juragan.svg'
      }
      if (name === 'saudagar') {
        return 'https://storage.googleapis.com/komerce/assets/svg/Saudagar.svg'
      }
      return null
    },

    async fetchSummaryData() {
      try {
        this.loading = true
        const res = await newAxiosIns.get(`/komship/api/v1/admin/partner/${this.id}/risk-review`)

        const { data } = res.data
        if (!data) return

        let lastPickupDate = null
        let lastPickupTime = null
        if (data.last_pickup) {
          lastPickupDate = DAY_MONTH_YEAR(data.last_pickup)
          lastPickupTime = TIME(data.last_pickup)
        }
        // Format tanggal level terakhir
        let levelDate = null
        if (data.last_user_level && data.last_user_level.updated_at) {
          levelDate = DAY_MONTH_YEAR(data.last_user_level.updated_at)
        }
        this.summaryData = {
          lastPickup: {
            date: lastPickupDate,
            time: lastPickupTime,
          },
          totalOrder: data.total_order,
          totalTransaksi: data.total_transaction,
          totalOngkir: data.total_shipping_cost,
          level: {
            from: data.last_user_level.prev_level_name || 'Regular',
            to: data.last_user_level.level_name,
            fromIcon: this.getIconLevel(data.last_user_level.prev_level_name || 'Regular'),
            toIcon: this.getIconLevel(data.last_user_level.level_name),
            date: levelDate,
          },
          rasioProblem: {
            percentage: data.problem_ratio.percentage,
            ratio: `${data.problem_ratio.top_problem_comparison[0]}/${data.problem_ratio.top_problem_comparison[1]}`,
            detail: `${data.problem_ratio.top_problem_description} ${data.problem_ratio.top_problem_percentage}% (${data.problem_ratio.top_problem_comparison[0]}/${data.problem_ratio.top_problem_comparison[1]})`,
          },
          rasioRetur: {
            percentage: data.retur_percentage,
          },
        }
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data summary Komship' })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.summary-card {
  border: 1px solid #E2E2E2;
  border-radius: 10px;
  padding: 10px;
  background: #FFFFFF;
  min-width: 220px;
}

.card-icon {
  width: 24px;
  height: 24px;
  border-radius: 4.8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-label {
  font-size: 12px;
  color: #6B7280;
  font-weight: 400;
}

.card-value {
  font-size: 16px;
  font-weight: 600;
  color: #1A1A1A;
}

.card-sub {
  font-size: 12px;
  color: #828282;
}

.level-badge-wrapper {
  background: #FFF2E2;
  border-radius: 8px;
  padding: 6px 8px;
  width: fit-content;
}

.level-badge-from {
  font-size: 14px;
  font-weight: 600;
  color: #F95031;
}

.arrow {
  font-size: 12px;
  color: #626262;
}

.level-badge-to {
  font-size: 14px;
  font-weight: 600;
  color: #F95031;
}

.problem-detail {
  display: flex;
  align-items: center;
  gap: 4px;
  background: #FFF5F5;
  border-radius: 6px;
  padding: 4px 8px;
  width: fit-content;
}

@media screen and (max-width: 768px) {
  .summary-card {
    min-width: calc(50% - 8px);
  }
}

@media screen and (max-width: 480px) {
  .summary-card {
    min-width: 100%;
  }
}
</style>

<style>
.tooltip .tooltip-inner {
  font-size: 14px;
  max-width: 250px;
  padding: 10px 6px;
  white-space: nowrap;
  background-color: #fff;
  color: #333;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

</style>
